import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=2ca463de&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports